import DonationCard from '@/core/components/DonationCard/DonationCard';

export default DonationCard;
